import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
export function FinalCtaSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-65" data-mp="3qt9nh740a0v5">
      <div className="mx-auto max-w-6xl px-4" data-id="element-66" data-mp="3vsmc9xefti0d">
        <div className="mx-auto max-w-2xl text-center" data-id="element-67" data-mp="3vrb8hxkzsa99">
          <Countdown label="⏰ El precio cierra en:" data-id="element-68" data-mp="2y5434lgv6dvu" />
        </div>

        <div className="mt-12" data-id="element-69" data-mp="2y2rbthp7ur64">
          <PricingCards compact data-id="element-70" data-mp="333p08c0tkhg2" />
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/60" data-id="element-71" data-mp="334gkwrsvourk">
          <span className="inline-flex items-center gap-1.5" data-id="element-72" data-mp="380yo3n8k8l1s">
            <LockIcon className="h-4 w-4 text-[var(--violet-light)]" aria-hidden="true" data-id="element-73" data-mp="3cutflcueq4bf" />
            Pago 100% seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-74" data-mp="2kcxl0tu5hwtr">
            <ZapIcon className="h-4 w-4 text-[var(--violet-light)]" aria-hidden="true" data-id="element-75" data-mp="2kbcq333xcbvd" />
            Acceso en 5 minutos
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-76" data-mp="28dfaqpwyqlaw">
            <ShieldCheckIcon className="h-4 w-4 text-[var(--violet-light)]" aria-hidden="true" data-id="element-77" data-mp="23lp0ejy0zxjh" />
            Garantía 7 días
          </span>
        </div>
        <p className="mt-3 text-center text-sm text-white/50" data-id="element-78" data-mp="1um1uply9k5km">
          Mercado Pago · Tarjeta · Transferencia
        </p>
      </div>
    </section>;
}